import { z } from "zod";
import { sonicTraitsSchema } from "../../sonic-traits/schema.js";
// Per-song override of the band-derived sonic traits (spec §4.4). One event with
// a `mode` discriminant: `custom` carries the traits that replace the band's,
// `inherit` discards the override and re-inherits the band. "Go back to the band"
// is a NEW event, never a delete (invariant #1). Born at v1 — no upcaster.
export const bandSonicTraitsOverriddenPayloadSchema = z.discriminatedUnion("mode", [
    z.object({
        mode: z.literal("custom"),
        traits: sonicTraitsSchema,
    }),
    z.object({
        mode: z.literal("inherit"),
    }),
]);
//# sourceMappingURL=sonic-traits.js.map